// extracted by mini-css-extract-plugin
export default {"profilepic":"RowIntro_profilepic__PafaR","hello":"RowIntro_hello__IRqMy","intro":"RowIntro_intro__4jc5C","h3":"RowIntro_h3__I8sbl","h5":"RowIntro_h5__EczA8"};